"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.andThen = exports.map = exports.isFailure = exports.isSuccess = exports.failure = exports.success = void 0;
class Success {
    constructor(value) {
        this.success = true;
        this.value = value;
    }
    map(f) {
        return success(f(this.value));
    }
    mapError(_f) {
        return success(this.value);
    }
    andThen(f) {
        return f(this.value);
    }
    orElse(_f) {
        return success(this.value);
    }
    withDefault(_fallback) {
        return this.value;
    }
    unsafe() {
        return this.value;
    }
}
class Failure {
    constructor(error) {
        this.success = false;
        this.error = error;
    }
    map(_f) {
        return failure(this.error);
    }
    mapError(f) {
        return failure(f(this.error));
    }
    andThen(f) {
        return failure(this.error);
    }
    orElse(f) {
        return f(this.error);
    }
    withDefault(fallback) {
        return fallback;
    }
    unsafe() {
        throw new Error(`Could not unwrap the result because it is a failure.`);
    }
}
function success(value) {
    return new Success(value);
}
exports.success = success;
function failure(error) {
    return new Failure(error);
}
exports.failure = failure;
const isSuccess = (result) => result.success === true;
exports.isSuccess = isSuccess;
const isFailure = (result) => result.success === false;
exports.isFailure = isFailure;
const map = (fn) => {
    return (...arr) => {
        if (arr.every(exports.isSuccess)) {
            const resolvedArgs = arr.map(e => e.value);
            return success(fn(...resolvedArgs));
        }
        for (let result of arr) {
            if (result.success === false) {
                return failure(result.error);
            }
        }
        throw new Error('Result.map did not find any success or error. This is not supposed to happen.');
    };
};
exports.map = map;
// TODO: Missing unit tests 
const andThen = (fn) => {
    return (...arr) => {
        if (arr.every(exports.isSuccess)) {
            const resolvedArgs = arr.map(e => e.value);
            return success(fn(...resolvedArgs));
        }
        for (let result of arr) {
            if (result.success === false) {
                return failure(result.error);
            }
        }
        throw new Error('Result.map did not find any success or error. This is not supposed to happen.');
    };
};
exports.andThen = andThen;
